import React, { useEffect } from "react";
import { Row, Col, Button } from "antd";
// import ProfileSuccess from "../../assets/images/profile_success.png";
import SuccessIcon from "../../assets/images/success-icon.PNG";
import { BsTags } from "react-icons/bs";
import { useSelector } from "react-redux";
function OrderSuccess({ backToCatalog }) {

  // just remove the selectedCurrency key from local storage so the user when visit the
  // shoppingCart page, will see the default key from there.
  useEffect(() => {
    localStorage.removeItem('selectedCurrency')
  }, [])

  const orderData = useSelector((store) => store.UserReducer.orderData);

  return (
    <Row justify="center" style={{ padding: "2rem", marginTop: "3rem" }}>
      <Col span={24} xl={24} lg={24} md={24} xs={24} sm={24}>
        <Row justify="start" gutter={[10, 0]}>
          <Col
            xl={6}
            lg={6}
            md={6}
            xs={6}
            sm={6}
            style={{
              display: "flex ",
              justifyContent: "end",
            }}
          >
            <img src={SuccessIcon} style={{ objectFit: 'none' }} />
          </Col>
          <Col xl={12} lg={12} md={12} xs={18} sm={18}>
            <Row gutter={[0, 0]} justify="start">
              <Col>
                <h5 style={{ color: "#f57c00", fontSize: '18px' }} className="text-left">
                  THANK YOU FOR SHOPPING WITH US
                </h5>
              </Col>
              <Col>
                <p className="text-left">
                  Your Order#
                  <span
                    style={{
                      color: "#02b7a6",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    {orderData.order_number}
                  </span>
                  has been successfully placed.
                </p>
              </Col>
              <Col>
                <p
                  className="text-left"
                  style={{
                    color: " #6d7d7c",
                  }}
                >
                  For further details please check your email.
                </p>
              </Col>
              <Col
                style={{ marginTop: "20px" }}
                xl={10}
                lg={10}
                md={10}
                xs={10}
                sm={10}
              >
                <Button
                  style={{
                    backgroundColor: "#f57c00 ",
                    color: "#fff",
                    border: "none",
                  }}
                  onClick={() => backToCatalog()}
                >
                  GO BACK TO CATALOG
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default OrderSuccess;
